// src/services/socketService.js
import { io } from 'socket.io-client';
import { useEffect, useState } from 'react';

// Singleton pour la connexion socket
let socket;

export const initializeSocket = () => {
  if (!socket) {
    socket = io(process.env.REACT_APP_BACKEND_URL, {
      keepAlive: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    setInterval(() => {
      if (socket.connected) {
        socket.emit('keepAlive');
      }
    }, 30000);

    socket.on('keepAliveResponse', () => {
      console.log('Keep alive response received');
    });

    socket.on('connect', () => {
      console.log('Connected to the Socket.IO server');
    });

    socket.on('disconnect', () => {
      console.log('Disconnected from the Socket.IO server');
    });
  }

  return socket;
};

export const useSocket = (orderId) => {
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const socket = initializeSocket();

    const handleConnect = () => {
      setIsConnected(true);
    };

    const handleDisconnect = () => {
      setIsConnected(false);
    };

    socket.on('connect', handleConnect);
    socket.on('disconnect', handleDisconnect);

    setIsConnected(socket.connected);

    return () => {
      socket.off('connect', handleConnect);
      socket.off('disconnect', handleDisconnect);
    };
  }, []);

  return { socket: initializeSocket(), isConnected };
};

// Hook spécifique pour les mises à jour de statut de commande
export const useOrderStatusUpdates = (orderId, onStatusUpdate) => {
  const { socket, isConnected } = useSocket();

  useEffect(() => {
    if (!orderId) return;

    const eventName = `orderStatusUpdate ${orderId}`;
    const handleStatusUpdate = (change) => {
      console.log('Order status updated:', change);
      onStatusUpdate(change);
    };

    socket.on(eventName, handleStatusUpdate);

    return () => {
      socket.off(eventName, handleStatusUpdate);
    };
  }, [orderId, socket, onStatusUpdate]);

  return { isConnected };
};

export const useOrderManualVerificationUpdates = (orderId, onStatusUpdate) => {
  const { socket, isConnected } = useSocket();

  useEffect(() => {
    if (!orderId) return;

    const eventName = `manualVerification ${orderId}`;
    const handleStatusUpdate = (change) => {
      onStatusUpdate(change);
    };

    socket.on(eventName, handleStatusUpdate);

    return () => {
      socket.off(eventName, handleStatusUpdate);
    };
  }, [orderId, socket, onStatusUpdate]);

  return { isConnected };
};
